import { Sun } from "lucide-react";
import { MARQUEE_ITEMS } from "@/lib/site";

export const Marquee = ({ items = MARQUEE_ITEMS }) => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="overflow-hidden bg-paper-deep border-y border-ink/10 py-5 md:py-7"
  >
    <div className="animate-marquee flex w-max whitespace-nowrap">
      {[0, 1].map((half) => (
        <div key={half} className="flex items-center">
          {items.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="font-serif text-4xl md:text-6xl font-medium tracking-tight text-ink/80 px-6 md:px-10">
                {item}
              </span>
              <Sun className="text-terra shrink-0" size={26} />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
